import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import type { Amount } from "./useTransactionPaymentRequestDetails"

export type ListedPaymentPlanConsentDto = {
  id: string
  paymentPlanId: string
  amount: Amount
  intervalValue: number
  intervalUnit: string
  nextDueDate: string
  recipientName: string
  status: string
  recipientCompany: {
    name: string
    contactNumber: string
    emailAddress: string
    feeMultiplier: number
    websiteUrl: string
    address: {
      streetNumberAndName: string
      apartmentNumber: string
      city: string
      zipCode: string
      state: string
      country: string
    }
  }
}

export type PaymentPlanConsentListResponse = {
  consents: ListedPaymentPlanConsentDto[]
}

export function usePaymentPlanConsentList() {
  return useQuery<PaymentPlanConsentListResponse>({
    queryKey: ["paymentPlanConsent", "list"],
    queryFn: async () => {
      const response = await fetcher(
        "/Transaction/PaymentPlanConsent",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
  })
}
